import axios from "axios";
const BASE_URL = "https://praneeshinfotech.com/kongudevapi/api/masters";

const api = axios.create({
    baseURL: BASE_URL,
    headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export const masterConfigs = [
    { name: "Gender", slug: "gender" },
    { name: "Profile Created By", slug: "profile-created-by" },
    { name: "Occupation", slug: "occupations", },
    { name: "Designation", slug: "designation" },
    { name: "Family Type", slug: "family-type" },
    {
        name: "Height",
        slug: "height",
        extraFields: [
            { name: "height_cm", label: "Height (cm)", type: "number", min: 50, max: 300 },
        ],
    },
    {
        name: "Weight",
        slug: "weight",
        extraFields: [
            { name: "weight_kg", label: "Weight (kg)", type: "number", min: 20, max: 300 },
        ],
    },
    { name: "Blood Group", slug: "blood-group" },
    { name: "Color", slug: "color" },
    { name: "Education", slug: "education" },
    { name: "Dhosam", slug: "dhosam" },
    { name: "Nakshatram", slug: "nakshatram" },
    { name: "Rasi", slug: "rasi" },
    {
        name: "Paadam",
        slug: "paadam",
        extraFields: [
            {
                name: "paadam_number",
                label: "Paadam Number",
                type: "select",
                options: [
                    { value: "1", label: "Paadam 1" },
                    { value: "2", label: "Paadam 2" },
                    { value: "3", label: "Paadam 3" },
                    { value: "4", label: "Paadam 4" },
                ],
            },
        ],
    },
    { name: "Marital Status", slug: "marital-status" },
    { name: "State", slug: "state" },
    {
        name: "District",
        slug: "district",
        extraFields: [
            {
                name: "state_id",
                label: "State",
                type: "reference",
                reference: "state",
            },
        ],
    },
    {
        name: "City",
        slug: "city",
        extraFields: [
            {
                name: "district_id",
                label: "District",
                type: "reference",
                reference: "district",
            },
        ],
    },
    { name: "Family Koottam", slug: "family-koottam" },
    { name: "Family Temple", slug: "family-temple" },
    { name: "Family Temple Place", slug: "family-temple-place" },
];

export const getMasterList = async (slug) => {
    const response = await api.get(`/${slug}`);
    return response.data;
};

export const createMaster = async (slug, payload) => {
    const response = await api.post(`/${slug}`, payload);
    return response.data;
};

export const updateMaster = async (slug, rfId, payload) => {
    const response = await api.put(`/${slug}/${rfId}`, payload);
    return response.data;
};

export const updateMasterStatus = async (slug, rfId, status) => {
    const response = await api.patch(`/${slug}/${rfId}/status`, { status });
    return response.data;
};

export default api;